module.exports = __webpack_public_path__ + "img/more_activity.da16d873.png";